export default kendo.Observable.extend({

    /**
     * Build up an object that can track all of the selected items.
     * field: The field that holds selection state
     * selectedValue: the value of the field that counts as selected
     * uniqueField: A field that is unique on each object.  Defaults to using the id field of the first model that is passed in.
     * @param options {field, selectedValue, uniqueField}
     */
    init: function(options) {
        kendo.Observable.fn.init.call(this);

        this._handleChange = $.proxy(this._handleChange, this);

        this.field = options.field;
        this.uniqueField = options.uniqueField;
        this.selectedValue = options.selectedValue;

        this.reset();
    },

    _getUniqueField: function(item) {
        if (!this.uniqueField) {
            this.uniqueField = item.idField;
        }
        return this.uniqueField;
    },

    reset: function() {
        //This maps id->model for all items that are selected
        this.selected = {};
        this.selectedCount = 0;

        //This maps id->model for all items that have been changed
        this.changed = {};
        this.trigger("change");
    },

    /**
     * Bind an item to this tracker.
     * @param item item
     */
    bindItem: function(item) {
        this._unbindItem();
        var events = [];
        for (var i = 1; i < arguments.length; i++) {
            events.push(arguments[i]);
            item.bind(arguments[i], this._handleChange);
        }
        this._boundItem = {
            item: item,
            events: events
        };
    },

    /**
     * Update the current items in the datasource with the currently known changes
     * @param ds datasource
     */
    updateCurrent: function(ds) {
        var now = ds.view();
        var id = now.length ? this._getUniqueField(now[0]) : "";
        for (var i = 0; i < now.length; i++) {
            if (this.changed[now[i][id]]) {
                now[i].set(this.field, this.changed[now[i][id]][this.field]);
            }
        }
    },

    /**
     * Add previously selected items.
     * @param ds datasource
     */
    addSelected: function(ds) {
        var me = this;
        ds.fetch().done(function() {
            var sel = ds.view();
            me._addSelectedItems(sel);
        });
    },

    /**
     * Add previously selected items and force them into a selected state.
     * @param ds
     */
    forceChanged: function(ds) {
        var me = this;
        return ds.fetch().done(function() {
            var sel = ds.view();
            sel.forEach(function(item) {
                me.forceChangeOfOne(item);

            });
        });
    },

    /**
     * Add previously selected items and force them into a selected state.
     * @param item
     */
    forceChangeOfOne: function(item) {
        item.set(this.field, this.selectedValue);
        this._handleItemChange(item);
    },

    _addSelectedItems: function(sel) {
        for (var i = 0; i < sel.length; i++) {
            if (sel[i].get(this.field) == this.selectedValue) {
                this.selected[sel[i].get(this._getUniqueField(sel[i]))] = sel[i].toJSON();
            }
        }
        this.selectedCount = 0;
        for (var id in this.selected) {
            this.selectedCount++;
        }
        this.trigger("change");
    },

    _unbindItem: function() {
        if (this._boundItem) {
            for (var j = 0; j < this._boundItem.events.length; j++) {
                this._boundItem.item.unbind(this._boundItem.events[j], this._handleChange);
            }
            delete this._boundItem;
        }
    },

    _handleChange: function(e) {
        if (e.action == "itemchange" && e.field == this.field) {
            var item = e.items[0];
            this._handleItemChange(item);
        } else if (e.action == "remove" && e.items) {
            var item = e.items[0];
            this._handleItemRemove(item);
        } else if (e.action != "itemchange" && e.items) {
            // looks for changes triggered by actions other than itemchange; does NOT handle deletions
            e.sender.pauseRefresh && e.sender.pauseRefresh(true);
            var noChanges = true;
            for (var i = 0; i < e.items.length; i++) {
                if (this.changed[e.items[i][this._getUniqueField(e.items[i])]]) {
                    e.items[i].set(this.field, this.changed[e.items[i][this._getUniqueField(e.items[i])]][this.field]);
                    noChanges = false;
                }
            }
            e.sender.pauseRefresh && e.sender.pauseRefresh(false, noChanges);
        }
    },

    _handleItemChange: function(item) {
        var plain = item.toJSON();
        plain[this.field] = item[this.field]; //This allows transient fields to be used
        var id = this._getUniqueField(item);
        if (plain[this.field] == this.selectedValue && !this.selected[plain[id]]) {
            this.selectedCount++;
            this.selected[plain[id]] = plain;
            this.trigger("change");
            this.trigger("itemChange");
        } else if (plain[this.field] != this.selectedValue && this.selected[plain[id]]) {
            delete this.selected[plain[id]];
            this.selectedCount--;
            this.trigger("change");
            this.trigger("itemChange");
        }
        this.changed[plain[id]] = plain;
    },

    /**
     * If the item being removed was checked, update the selectedCount.
     * @param item
     * @private
     */
    _handleItemRemove: function(item) {
        item[this.field] = item[this.field]; //This allows transient fields to be used
        var id = this._getUniqueField(item);
        if (item[this.field] == this.selectedValue) {
            delete this.selected[item[id]];
            this.selectedCount--;
            this.trigger("change");
            this.trigger("itemChange");
        }
    },

    /**
     * Get a array holding the selected items
     * @returns {*}
     */
    getSelected: function() {
        var now = [];
        for (var id in this.selected) {
            if (this.selected.hasOwnProperty(id)) {
                now.push(this.selected[id]);
            }
        }
        return now;
    },

    getSelectedDataSource: function() {
        var ds = new kendo.data.DataSource({
            data: this.getSelected()
        });
        this.bind("change", function() {
            ds.data(this.getSelected());
        });
        return ds;
    },

    getChanges: function() {
        var now = [];
        for (var id in this.changed) {
            if (this.changed.hasOwnProperty(id)) {
                now.push(this.changed[id]);
            }
        }
        return now;
    },

    /*
     * @returns {number} Number of items currently selected.
     */
    getSelectedCount: function() {
        return this.selectedCount;
    }

});